import { LocalStorageService } from './../../../core/services/local-storage.service';
import { environment } from './../../../../environment/environment';
import { NotificationService } from './../../../core/services/notification/notification.service';
import { ChangeDetectorRef, Component } from '@angular/core';
import { catchError, finalize, Observable, of, Subject, Subscription, takeUntil } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  notifications: any;
  unreadNotificationCount: number = 0;
  base_url_img = environment.baseUrlGalery;
  company_id: any;
  itemsPerPage: number = 5
  currentPage: number = 0
  notificationsSubscription!: Subscription;
  pagination : boolean =false;
  startIndex: number = 0
  endIndex: number = 5
  totalItems:any
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private notificationService: NotificationService,
    private changeDetectorRef: ChangeDetectorRef,
    private localStorageService: LocalStorageService,
    private spinner: NgxSpinnerService,
    private router:Router
  ) {}

  ngOnInit() {
    this.notificationsSubscription =
      this.notificationService.messages$.subscribe((notification) => {
        this.notifications = this.notifications.concat(notification);
        this.changeDetectorRef.detectChanges();
      });
    this.getNotification();
    this.company_id = this.localStorageService.getData('clientConnected');
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex
      this.endIndex = event.endIndex
      this.itemsPerPage = event.itemsPerPage,
        this.currentPage = event.currentPage
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
        this.getNotification()
        }
    }
  }

  readNotification(id: any, index: number): Observable<any> {
      this.spinner.show();
      const data = { id };
     
      return this.notificationService.readNotification(data).pipe(
        catchError(err => {
          return of(null); // Return an empty observable on error
        }),
        finalize(() => {
          this.spinner.hide();       
        })
      );
    }

  getNotification() {
  
    (this.company_id = this.localStorageService.getData('clientConnected')),
    this.spinner.show()
      this.notificationService
        .getListOfNotification(this.company_id,this.pageSize, this.currentPage+1)
        .subscribe({
          next: (res) => {
            this.notifications = res.data.data.data;
            this.totalItems = res.data.data.total;
            this.unreadNotificationCount = this.notifications.filter(
              (notification: any) => notification.read === 0
            ).length;
            this.spinner.hide()
          },
          error: (e) => {
            this.spinner.hide()
          },
        });
  } onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      this.getNotification();
    }
  notificationRedirection(notification: any, index: number) {

  this.readNotification(notification.id, index).subscribe(() => {
    switch (notification.state) {
      case '1':
        this.router.navigate(['/liste-candidats']);
        break;
      case '5':
        this.router.navigate(['/consultant-externe']);
        break;
      case '6':
      case '7':
      case '11':
        this.router.navigate(['/consultants']);
        break;
      case '8':
      case '9':
        this.router.navigate(['/employee']);
        break;
      case '10':
        this.router.navigate(['/offres-emploi/candidature'], 
          {
            state : {candidateFullName: notification.sender.first_name.concat(' ', notification.sender.last_name)}
          });
        break;
      case '12':
      case '19':
        this.router.navigate(['/cra']);
        break;
      case '13':
        this.router.navigate([`/entreprises/details-entreprise/${notification.sender.company_id}`]);
        break;
      case '14':
        this.router.navigate(['/evaluation/reçus']);
        break;
      case '15':
        this.router.navigate(['/evaluation/pv']);
        break;
      case '17':
      case '18':
        this.router.navigate(['/cra/liste-timesheet']);
        break;
      case '21':
        this.router.navigate(['/candidatsclientfinal']);
        break;
      // Add future redirections here if needed
      default:
        break;
    }
  });
}

}
